import { FC } from "react";
import { Badge } from "@vilocnv/allsetra-core";
import { KeyStatus } from "domain/keys/entities/dtos/key-history.dto";

type BadgeColorScheme =
  | "success"
  | "error"
  | "warning"
  | "grey"
  | "info"
  | "info-blue"
  | "purple"
  | "default";

export interface KeyStatusBadgeProps {
  keyStatus?: KeyStatus;
  translator: (key: string) => string;
}

const getStatusColorScheme = (status: KeyStatus): BadgeColorScheme => {
  switch (status) {
    case KeyStatus.Active:
      return "success";
    case KeyStatus.Blocked:
      return "error";
    case KeyStatus.Deleted:
      return "error";
    case KeyStatus.Inventory:
      return "grey";
    default:
      return "default";
  }
};

const getStatusLabel = (
  status: KeyStatus,
  translator: (key: string) => string
): string => {
  switch (status) {
    case KeyStatus.Active:
      return translator("keyStatusFilter.active");
    case KeyStatus.Blocked:
      return translator("keyStatusFilter.blocked");
    case KeyStatus.Deleted:
      return translator("keyStatusFilter.deleted");
    case KeyStatus.Inventory:
      return translator("keyStatusFilter.inventory");
    default:
      return translator("keyHistory.status.unknown");
  }
};

const KeyStatusBadge: FC<KeyStatusBadgeProps> = ({ keyStatus, translator }) => {
  if (keyStatus === undefined) {
    return null;
  }
  const colorScheme = getStatusColorScheme(keyStatus);
  const label = getStatusLabel(keyStatus, translator);

  return <Badge colorScheme={colorScheme}>{label}</Badge>;
};

export default KeyStatusBadge;
